import { render, staticRenderFns } from "./UserModeration.vue?vue&type=template&id=6c1e5072&scoped=true"
import script from "./UserModeration.vue?vue&type=script&lang=js"
export * from "./UserModeration.vue?vue&type=script&lang=js"
import style0 from "./UserModeration.vue?vue&type=style&index=0&id=6c1e5072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1e5072",
  null
  
)

export default component.exports